import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './translations.json';
type SupportedLanguage = keyof typeof translations;

const DARK_CARD_BG = '#121824';
const DARK_BORDER = '#1e2638';

const AssessmentNotEligible = () => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;
  return (
    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
      <Card
        sx={{
          maxWidth: 460,
          width: '100%',
          textAlign: 'center',
          p: 3,
          borderRadius: '16px',
          backgroundColor: DARK_CARD_BG,
          borderColor: DARK_BORDER,
          borderWidth: 1,
          borderStyle: 'solid',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.3)'
        }}
      >
        <CardContent>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2.5
            }}
          >
            <FontAwesomeIcon
              icon={faBan}
              style={{ color: '#ef4444', fontSize: '2.2rem' }}
            />
          </Box>
          <Typography variant="h5" fontWeight={700} color="#ffffff" mb={1.5}>
            {content.title}
          </Typography>
          <Typography variant="body2" sx={{ color: '#8c94a4', lineHeight: 1.6 }}>
            {content.description}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AssessmentNotEligible;